import { fade } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabsContainer: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
      background: fade(theme.palette.text.primary, 0.1)
    }
  })
);
